import { colors, scale } from "@capioweb/ui-components/src"
import React from "react"
import styled from "styled-components"

interface PaginationBtnProps {
	bgColor?: boolean
	onclick?: () => void
	disabled?: boolean
	ariaLabel?: string
	children?: React.ReactNode
}

const StyledPaginationBtnWrapper = styled.div`
	position: relative;
	width: 100%;

	&::before {
		content: "";
		display: block;
		padding-top: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}
`

const BtnBaseStyle = `
	width: ${scale.px(6)};
	height: ${scale.px(6)};
	border: 1px solid ${colors.blue33};
	border-radius: 8px;
`

const StyledPaginationBtn = styled.button<PaginationBtnProps>`
	${BtnBaseStyle}
	background-color: ${(props) =>
		props.bgColor ? `${colors.blue33}` : `${colors.white}`};

	&:hover {
		background-color: ${(props) =>
			props.bgColor ? `${colors.blue33}` : `${colors.blue11}`};
	}
`
const StyledPaginationDiv = styled.div<PaginationBtnProps>`
	${BtnBaseStyle}
	display: flex;
	background-color: ${colors.white};
`

export const PaginationButton: React.FC<PaginationBtnProps> = ({
	bgColor,
	disabled,
	ariaLabel,
	onclick,
	children,
}) => {
	return (
		<StyledPaginationBtnWrapper>
			{disabled ? (
				<StyledPaginationDiv>{children}</StyledPaginationDiv>
			) : (
				<StyledPaginationBtn
					aria-label={ariaLabel}
					type="button"
					bgColor={bgColor}
					onClick={onclick}
				>
					{children}
				</StyledPaginationBtn>
			)}
		</StyledPaginationBtnWrapper>
	)
}
